import {css} from '@emotion/css';

import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: CtaCard;
    width: 100%;
    height: 100%;
  `,
  dialogue: css`
    label: CtaCard__dialogue;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
  `,
  dialogueContents: css`
    label: CtaCard__dialogueContents;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  contents: css`
    label: ctaCard__contents;
    display: flex;
    width: 100%;
    ${mq(Breakpoints.DESKTOP)} {
      flex-direction: column;
    }
  `,
  imageContainer: css`
    label: ctaCard__imageContainer;
    flex-shrink: 1;
    max-width: 7rem;
    margin-right: 1.5rem;
    ${mq(Breakpoints.DESKTOP)} {
      flex-shrink: unset;
      max-width: unset;
      margin-right: 0;
      margin-bottom: ${spacing.XS};
      text-align: center;
    }
  `,
  image: css`
    label: CtaCard__image;
    max-width: 6.5rem;
    ${mq(Breakpoints.DESKTOP)} {
      max-width: unset;
      max-height: 12.8rem;
    }
  `,
  header: css`
    label: CtaCard__header;
    color: ${colours.font.INFORMATION};
    ${mq(Breakpoints.DESKTOP)} {
      text-align: center;
    }
  `,
  paragraph: css`
    label: CtaCard__paragraph;
    color: ${colours.font.ASSISTIVE};
    ${mq(Breakpoints.DESKTOP)} {
      text-align: center;
    }
  `,
  button: css`
    label: CtaCard__button;
    display: block;
    word-break: keep-all;
    && {
      width: 100%;
    }
  `,
  trustpilot: css`
    label: CtaCard__trustpilot;
    margin-top: ${spacing.XS};
    overflow-x: hidden;
  `,
  trustpilotWidget: css`
    label: CtaCard__trustpilotWidget;
    ${mq(Breakpoints.TABLET)} {
      width: calc(100% + 1.3333rem);
    }
  `,
};

export const gatsbyImageElementStyle = {
  maxHeight: '12.8rem',
};

export default styles;
